import { type PrimitiveAtom, useSetAtom } from 'jotai'
import { useLocation, useNavigate } from 'react-router'
import { useMount } from 'react-use'

import { exists } from '~/utils'

export const useRestoreOnMount = (
  restoreParams: (state: unknown) => void,
  isTabulationReadyAtom: PrimitiveAtom<boolean>,
) => {
  const navigate = useNavigate()
  const location = useLocation()
  const setIsTabulationReady = useSetAtom(isTabulationReadyAtom)

  useMount(() => {
    const rest = restoreParams(location.state)

    if (exists(rest)) {
      navigate(location.pathname, { state: rest, replace: true })
    }

    setIsTabulationReady(true)
  })
}
